import { useMutation } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { DeleteInvoiceRequestItem } from 'src/types/edi';
import axiosInstance from 'src/utils/axios';

const useDeleteInvoiceMutation = () =>
  useMutation({
    mutationFn: async (body: DeleteInvoiceRequestItem[]) => {
      await axiosInstance.post(api.deleteEDIInvoice, body);
    },
  });

export default useDeleteInvoiceMutation;
